import { IApplicationState } from '../../types/redux';

/**
 * Выбирает все галереи Было-Стало
 */
export const selectPostContentBlockquotes = ({ postContentBlockquotes }: IApplicationState) =>
  postContentBlockquotes.items;
